import React from 'react';

const IconYouTube = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <title>Youtube</title>
    <path data-name="layer1"
      d="M9-.011v64l53-32-53-32z"></path>
  </svg>
);

export default IconYouTube;